import { Box } from '@mui/joy';
import { ICellEditorParams } from 'ag-grid-community';

import { NON_EMPTY } from 'core/constants';
import { CorporateLocationAutocomplete } from 'corporate/elements';
import { CorporateLocationType } from 'corporate/enums';

interface IProps extends ICellEditorParams {
  isAlternateVersionEnabled: boolean;
  onValueChange: (value: unknown) => void;
}

export const CorporateLocationCellEditor = ({
  data,
  value,
  isAlternateVersionEnabled,
  onValueChange,
  stopEditing,
}: IProps) => (
  <Box sx={{ width: '100%' }}>
    <CorporateLocationAutocomplete
      name="corporateLocationCellEditor"
      value={{
        ...value,
        name: value?.addressName,
        vendorId: isAlternateVersionEnabled ? value?.externalLocationId : value?.vendorIdentifier,
      }}
      onChange={(_, option) => {
        if (isAlternateVersionEnabled && !option?.id) {
          return;
        }

        onValueChange(
          option
            ? {
                ...option,
                externalLocationId: option?.externalLocationId || option?.vendorId,
              }
            : null
        );

        stopEditing();
      }}
      requestPayload={{
        quotePart: { id: data?.id },
        filters: { vendorId: NON_EMPTY },
        viewBy: {
          partNumber: data.part,
          manufacturerId: data.manufacturerId,
          uom: data.uom,
        },
      }}
      queryOptions={{
        mapResult: ({ records, rest }: any) => ({
          ...rest,
          records: records.map((record) => ({
            id: record.id,
            addressName: record.name,
            vendorIdentifier: record.vendorId,
            inventoryTotalQty: record.inventoryQuantity,
            ...record,
          })),
        }),
      }}
      wrapperStyle={{ width: '100%' }}
      disableClearable={isAlternateVersionEnabled}
      displayInventory
      isAlternateVersionEnabled={isAlternateVersionEnabled}
      type={CorporateLocationType.SHIPPING}
    />
  </Box>
);
